import { sha256 } from 'js-sha256';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { cleanExcerpt } from './clean-excerpt';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getUserPath } from './get-user-path';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { getTeamPath } from './get-team-path';

// copied over from @confluence/hash
const hash = (data: any, asBytes: boolean = false) => {
	const hash = sha256.create();
	hash.update(data);
	if (asBytes) {
		return hash.array();
	}
	return hash.hex();
};

export const hashDataAsByte: (data: any) => number[] = (data: any) => {
	return hash(data, true) as number[];
};

export const hashData: (data: any) => string = (data: any) => {
	return hash(data) as string;
};
